// @ts-strict-ignore
import strings from 'mobile_web/strings'
import React, { FC, ReactElement } from 'react'
import { Helmet } from 'react-helmet'

interface MetaHeaderProps {
	title: string
	description: string
	pageEndIndex?: number
}

const MetaHeader: FC<MetaHeaderProps> = ({ title, description, pageEndIndex }): ReactElement => {
	const schema = {
		type: 'application/ld+json',
		innerHTML: JSON.stringify({
			'@type': 'Article',
			articleBody: description || title,
			alternativeHeadline: title,
			pageStart: 0,
			pageEnd: pageEndIndex,
			accessMode: ['auditory', 'textual', 'visual', 'musicOnVisual', 'textOnVisual'],
		}),
	}

	return (
		<Helmet
			title={`${title ? `${title} - ` : ''}${strings.tour_details_title}`}
			meta={[
				{ name: 'description', content: description || title },
				{ property: 'og:type', content: 'website' },
				{ property: 'og:title', content: title },
				{ property: 'og:description', content: description || title },
				{ property: 'og:url', content: window.location.href },
			]}
			script={[schema]}
		/>
	)
}

export default MetaHeader
